import { CreateThemePack } from '@/types/theme-packs.types';
import { CreateNewColorPack } from '@/connection/theme-packs';
import { TemplatesReducerCreator } from '../types';

const createThemePackReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async (themePack: CreateThemePack) => {
      return CreateNewColorPack(themePack);
    },
    {
      fulfilled: (state, action) => {
        if (state.themePacks) {
          state.themePacks.push(action.payload);
        } else {
          state.themePacks = [action.payload];
        }
      },
      pending: (state) => {
        state.creatingThemPack = true;
      },
      rejected: (_, action) => {
        console.error(action.error);
      },
      settled: (state) => {
        state.creatingThemPack = false;
      },
    }
  );
};

export default createThemePackReducer;
